function updateQty(key, newQty) {
    if (newQty < 0) return;
    const form = document.querySelector('#cart-form');
    // For simple implementation, we submit the form
    // In a full AJAX version, we would use FETCH API to /cart/update.js
    const input = form.querySelector(`input[data-key="${key}"]`);
    input.value = newQty;
    form.submit();
  }
